import { render, staticRenderFns } from "./indexEdit.vue?vue&type=template&id=f67e0f52&scoped=true"
import script from "./indexEdit.vue?vue&type=script&lang=js"
export * from "./indexEdit.vue?vue&type=script&lang=js"
import style0 from "./indexEdit.vue?vue&type=style&index=0&id=f67e0f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67e0f52",
  null
  
)

export default component.exports